import { render, staticRenderFns } from "./SimplifiedAppointmentsCalendar.vue?vue&type=template&id=401f7d51&scoped=true&"
import script from "./SimplifiedAppointmentsCalendar.vue?vue&type=script&lang=js&"
export * from "./SimplifiedAppointmentsCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f7d51",
  null
  
)

export default component.exports